module.exports = __webpack_public_path__ + "img/help-icon-dark.29262598.svg";